import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset scroll position on route change. React Router preserves the previous
 * page's scroll offset across navigations, so clicking e.g. "Get started" from
 * the pricing section (near the page bottom) would drop the user into the
 * middle of /dashboard instead of the login form at the top. This sends every
 * route change back to the top — unless the URL carries a #hash, in which case
 * we scroll to that anchor instead (so /docs#x402 still works).
 */
export default function ScrollToTop() {
  // `key` changes on every navigation action — including clicking a Link to the
  // current route (e.g. the footer "Get your keys" while already on /dashboard).
  // Keying the effect on it (not just pathname) makes those same-route clicks
  // scroll to top too, instead of being a silent no-op.
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'instant', block: 'start' });
        return;
      }
    }
    // behavior:'instant' overrides the global `scroll-behavior: smooth` so a
    // route change jumps to the top instead of animating a long scroll.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, key]);

  return null;
}
